module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image10c.f02d6209.jpg";